module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "src": require("../images/banner.png"),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("提供保障")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("每人单日/单次最高赔付20000元"), _c('br'), _vm._v("每人累计最高赔付100000元")]), _vm._v(" "), _c('p', {
    staticClass: "doc_title"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙安卓版4.0或iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d68ecb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/range.vue
// module id = 839
// module chunks = 1